import {useEffect, useMemo, useRef, useState} from 'react'
import {pick} from 'remeda'
import {deepEqual} from '../collection'
type Dim = {
  width: number
  height: number
}

/** get the state of an element even if it resizes. Based on the mantine version,with the initial rect size because playwright chromium doesn't get the observer size (not sur ewhy) */
export function useElementSize<T extends HTMLElement = HTMLDivElement>() {
  const frameID = useRef(0)
  const ref = useRef<T>(null)
  const [rect, setDimRaw] = useState<Dim>({width: 0, height: 0})

  const setDim = (dim: Dim) => {
    const newState = pick(dim, ['width', 'height'])
    if (newState.width && !deepEqual(newState, rect)) setDimRaw(newState)
  }

  const observer = useMemo(
    () =>
      typeof window !== 'undefined'
        ? new ResizeObserver((entries: any) => {
            const entry = entries[0]
            if (entry) {
              cancelAnimationFrame(frameID.current)
              frameID.current = requestAnimationFrame(() => {
                if (ref.current) setDim(entry.contentRect)
              })
            }
          })
        : null,
    []
  )

  useEffect(() => {
    if (ref.current) {
      setDim(ref.current.getBoundingClientRect())
      observer!.observe(ref.current)
    }
    return () => {
      observer!.disconnect()
      if (frameID.current) cancelAnimationFrame(frameID.current)
    }
  }, [ref.current])

  const {width, height} = rect

  return {ref, width, height} as const
}

// export function useElementSize<T extends HTMLElement = HTMLDivElement>(fallback?: Dim) {
//   const [ref, {width, height}] = useResizeObserver<T>()
//   const res = {ref, width, height}
//   return !res.width && !res.height && fallback ? {...res, ...fallback} : res
// }

// export const usePlaywrightCompatibleElementSize = <T extends HTMLElement = HTMLDivElement>() => {
//   const ref = useRef<T>(null)
//   const [{width, height}, setSize] = useState<{width: number; height: number}>({width: 0, height: 0})

//   useEffect(() => {
//     if (ref.current) {
//       const {width, height} = ref.current.getBoundingClientRect()
//       setSize({width, height})
//     }
//   }, [ref.current])

//   return {ref, width, height} as const
// }
